export const LAST_TIME_OPEN_CASE_ID = 'LAST_TIME_OPEN_CASE_ID';
